import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import {IndexComponent as ProcessIndexComponent} from './index/index.component';
import {EditComponent as ProcessEditComponent} from './edit/edit.component';
import {ProcessService} from '../../../services/api/quality-management/process.service';
import {IndexComponent as ProcessVersionIndexComponent} from './versions/index/index.component';
import {ProcessVersionService} from '../../../services/api/quality-management/process-version.service';

export const routes: Routes = [
  {
    path: '',
    component: ProcessIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.quality-management.processes.index.breadcrumb',
          translate: true,
          route: '/quality-management/processes'
        },
      ]
    }
  },
  {
    path: 'add',
    component: ProcessEditComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.QUALITYMANAGEMENT_PROCESS_CREATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.quality-management.processes.index.breadcrumb',
          translate: true,
          route: '/quality-management/processes'
        },
        {label: 'authenticated.quality-management.processes.create.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/current',
    component: ProcessEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      process: ProcessService,
    },
    data: {
      anyPermissionNeeded: [
        PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL,
        {permission: PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL, modelId: 'id'}
      ],
      breadcrumb: [
        {
          label: 'authenticated.quality-management.processes.index.breadcrumb',
          translate: true,
          route: '/quality-management/processes'
        },
        {dynamic: true, dataKey: 'process.ext_id', route: '/quality-management/processes/:id'},
        {label: 'authenticated.quality-management.processes.current.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id',
    component: ProcessEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      process: ProcessService,
    },
    data: {
      anyPermissionNeeded: [
        PERMISSION.QUALITYMANAGEMENT_PROCESS_UPDATE_ALL,
        {permission: PERMISSION.QUALITYMANAGEMENT_PROCESS_UPDATE_ALL, modelId: 'id'},
      ],
      breadcrumb: [
        {
          label: 'authenticated.quality-management.processes.index.breadcrumb',
          translate: true,
          route: '/quality-management/processes'
        },
        {dynamic: true, dataKey: 'process.ext_id', route: '/quality-management/processes/:id'},
        {label: 'authenticated.quality-management.processes.edit.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/versions',
    resolve: {
      process: ProcessService,
    },
    children: [
      {
        path: '',
        component: ProcessVersionIndexComponent,
        canActivate: [canActivateGuard],
        data: {
          anyPermissionNeeded: [
            PERMISSION.QUALITYMANAGEMENT_PROCESSVERSION_READ_ALL,
            {permission: PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL, modelId: 'id'},
          ],
          breadcrumb: [
            {
              label: 'authenticated.quality-management.processes.index.breadcrumb',
              translate: true,
              route: '/quality-management/processes'
            },
            {dynamic: true, dataKey: 'process.ext_id', route: '/quality-management/processes/:id'},
            {label: 'authenticated.quality-management.processes.versions.index.breadcrumb', translate: true,},
          ]
        }
      },
      {
        path: ':id',
        component: ProcessEditComponent,
        canActivate: [canActivateGuard],
        resolve: {
          processVersion: ProcessVersionService,
        },
        data: {
          anyPermissionNeeded: [
            PERMISSION.QUALITYMANAGEMENT_PROCESSVERSION_READ_ALL,
            {permission: PERMISSION.QUALITYMANAGEMENT_PROCESSVERSION_READ_ALL, modelId: 'id'},
          ],
          breadcrumb: [
            {
              label: 'authenticated.quality-management.processes.index.breadcrumb',
              translate: true,
              route: '/quality-management/processes'
            },
            {dynamic: true, dataKey: 'process.ext_id', route: '/quality-management/processes/:id'},
            {
              label: 'authenticated.quality-management.processes.versions.index.breadcrumb',
              translate: true,
              route: '/quality-management/processes/:id/versions'
            },
            {dynamic: true, dataKey: 'processVersion.version_number'},
          ]
        }
      }
    ]
  },
];
